import { useUserStore } from '@/store/userStore';
import { APP_MODES } from '@/helpers/constants';
import { useGetMe } from '@/hooks/shared/useGetMe';

export const SplitMode = ({ lender, borrower }) => {
  const mode = useUserStore(state => state.mode);
  const { isLender, isBorrower } = useGetMe();
  if (mode !== APP_MODES.split) return null;

  if (isLender && lender) return lender;
  if (isBorrower && borrower) return borrower;
};